/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveStatusChallengeResponse
 */
export interface ActiveStatusChallengeResponse {
    /**
     * The ID of the active status challenge
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    statusChallengeId: number;
    /**
     * The type of status challenge
     * @type {string}
     * @memberof ActiveStatusChallengeResponse
     */
    challengeType: ActiveStatusChallengeResponseChallengeTypeEnum;
    /**
     * The current status of the challenge
     * @type {string}
     * @memberof ActiveStatusChallengeResponse
     */
    status: ActiveStatusChallengeResponseStatusEnum;
    /**
     * When the challenge started
     * @type {Date}
     * @memberof ActiveStatusChallengeResponse
     */
    startDate: Date;
    /**
     * When the challenge ends (fixed date for challenge_0, 7 days from start for challenge_2)
     * @type {Date}
     * @memberof ActiveStatusChallengeResponse
     */
    endDate: Date;
    /**
     * Number of nights completed towards the challenge
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    nightsCurrent: number;
    /**
     * Amount spent towards the challenge (in USD)
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    spendingCurrent: number;
    /**
     * Nights required for Silver tier (5 for challenge_0)
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    nightsRequiredSilver?: number;
    /**
     * Spending required for Silver tier ($1,500 for challenge_0)
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    spendingRequiredSilver?: number;
    /**
     * Nights required for Gold tier (10 for challenge_0, null for challenge_2 which is Silver-only)
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    nightsRequiredGold?: number | null;
    /**
     * Spending required for Gold tier ($3,000 for challenge_0, null for challenge_2 which is Silver-only)
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    spendingRequiredGold?: number | null;
    /**
     * User's current tier
     * @type {string}
     * @memberof ActiveStatusChallengeResponse
     */
    currentTier?: ActiveStatusChallengeResponseCurrentTierEnum;
    /**
     * Current cashback percentage (3%, 5%, or 7%)
     * @type {number}
     * @memberof ActiveStatusChallengeResponse
     */
    cashbackPercentage?: number;
}


/**
 * @export
 */
export const ActiveStatusChallengeResponseChallengeTypeEnum = {
    StatusChallenge0: 'status_challenge_0',
    StatusChallenge1: 'status_challenge_1',
    StatusChallenge2: 'status_challenge_2',
    StatusChallenge3: 'status_challenge_3'
} as const;
export type ActiveStatusChallengeResponseChallengeTypeEnum = typeof ActiveStatusChallengeResponseChallengeTypeEnum[keyof typeof ActiveStatusChallengeResponseChallengeTypeEnum];

/**
 * @export
 */
export const ActiveStatusChallengeResponseStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Expired: 'expired'
} as const;
export type ActiveStatusChallengeResponseStatusEnum = typeof ActiveStatusChallengeResponseStatusEnum[keyof typeof ActiveStatusChallengeResponseStatusEnum];

/**
 * @export
 */
export const ActiveStatusChallengeResponseCurrentTierEnum = {
    Member: 'member',
    Silver: 'silver',
    Gold: 'gold'
} as const;
export type ActiveStatusChallengeResponseCurrentTierEnum = typeof ActiveStatusChallengeResponseCurrentTierEnum[keyof typeof ActiveStatusChallengeResponseCurrentTierEnum];


/**
 * Check if a given object implements the ActiveStatusChallengeResponse interface.
 */
export function instanceOfActiveStatusChallengeResponse(value: object): value is ActiveStatusChallengeResponse {
    if (!('statusChallengeId' in value) || value['statusChallengeId'] === undefined) return false;
    if (!('challengeType' in value) || value['challengeType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('nightsCurrent' in value) || value['nightsCurrent'] === undefined) return false;
    if (!('spendingCurrent' in value) || value['spendingCurrent'] === undefined) return false;
    return true;
}

export function ActiveStatusChallengeResponseFromJSON(json: any): ActiveStatusChallengeResponse {
    return ActiveStatusChallengeResponseFromJSONTyped(json, false);
}

export function ActiveStatusChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveStatusChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statusChallengeId': json['status_challenge_id'],
        'challengeType': json['challenge_type'],
        'status': json['status'],
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'nightsCurrent': json['nights_current'],
        'spendingCurrent': json['spending_current'],
        'nightsRequiredSilver': json['nights_required_silver'] == null ? undefined : json['nights_required_silver'],
        'spendingRequiredSilver': json['spending_required_silver'] == null ? undefined : json['spending_required_silver'],
        'nightsRequiredGold': json['nights_required_gold'] == null ? undefined : json['nights_required_gold'],
        'spendingRequiredGold': json['spending_required_gold'] == null ? undefined : json['spending_required_gold'],
        'currentTier': json['current_tier'] == null ? undefined : json['current_tier'],
        'cashbackPercentage': json['cashback_percentage'] == null ? undefined : json['cashback_percentage'],
    };
}

export function ActiveStatusChallengeResponseToJSON(json: any): ActiveStatusChallengeResponse {
    return ActiveStatusChallengeResponseToJSONTyped(json, false);
}

export function ActiveStatusChallengeResponseToJSONTyped(value?: ActiveStatusChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_challenge_id': value['statusChallengeId'],
        'challenge_type': value['challengeType'],
        'status': value['status'],
        'start_date': value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'].toISOString().substring(0,10),
        'nights_current': value['nightsCurrent'],
        'spending_current': value['spendingCurrent'],
        'nights_required_silver': value['nightsRequiredSilver'],
        'spending_required_silver': value['spendingRequiredSilver'],
        'nights_required_gold': value['nightsRequiredGold'],
        'spending_required_gold': value['spendingRequiredGold'],
        'current_tier': value['currentTier'],
        'cashback_percentage': value['cashbackPercentage'],
    };
}

